import React from "react";
import { connect } from "react-redux";
import BackButton from "./BackButton";
import ToggleButton from "./ToggleButton";
import AddRule from "./AddRule";
import Modal from "./Modal";
import "assets/scss/styles.css";
import pencil from "assets/img/pencil.svg";
import close from "assets/img/close.svg";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import Slide from "@material-ui/core/Slide";
import CustomInput from "components/CustomInput/CustomInput.jsx";

function Transition(props) {
 return <Slide direction="down" {...props} />;
}
class AddGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      smallModal: false,
      segment_name_data: "",
      segment_key: "",
      segment_name: ""
    };
  }
  handleChangeInput = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  handleClickOpen(modal, key) {
     var x = [];
     x[modal] = true;
     this.setState(x);
     this.setState({segment_key: key})
     this.setState({segment_name_data: this.props.segmentName[key]})
   }
   handleClose(modal) {
     var x = [];
     x[modal] = false;
     this.setState(x);
   }

  updateSegment() {
    this.props.dispatch({
      type: "UPDATE_SEGMENT_NAME",
      selectedIndex: this.state.segment_key,
      payload: this.state.segment_name_data
    });
    this.props.dispatch({ type: "Add_SEGMENT" });
    this.handleClose("smallModal")
  }

  render() {
    const { classes } = this.props;
    let val = this.props.tillSqlSelectionArrSegment;
    let selectedDataNew = "";
    return (
      <React.Fragment>
        <div className="addgroupmain2-wrap">
          <div
            className={val.length === 1 ? "addgroupmain2-c" : "addgroupmain2"}
          >
            {val.map((options, key) => (
              <div
                key={key}
                className={
                  val.length === 1 ? "addgrouplisting2-c" : "addgrouplisting2"
                }
                style={{ maxWidth: "100%" }}
              >
                <div className="addgrouptitle topradius">
                  <b style={{ color: "white" }}>
                    {this.props.segmentName[key]}
                  </b>
                  {" "}<i className="fa fa-edit" style={{color:"#FFF", fontSize: "10px"}} onClick={() => this.handleClickOpen("smallModal", key)}></i>
                  <div className="withoutbgbtngroup">
                    <a href="javascript:void(0)" className="withoutbgbtn">
                      <Modal
                        titleName="Add Rule"
                        buttonLabel="Add Rule"
                        selectedIndex={key}
                        selectedRule=""
                        mode="Create"
                        type="rule"
                        buttonType="add rule"
                        class="withoutbgbtn"
                      />
                    </a>
                  </div>
                </div>
                <div className="addgroupcontent2">
                  <AddRule key={key} selectedValue={options} index={key} />
                </div>
              </div>
            ))}
          </div>
          <br />
        </div>
        <Dialog
         classes={{
           root: classes.center + " " + classes.modalRoot,
           paper: classes.modal + " " + classes.modalSmall
         }}
         open={this.state.smallModal}
         TransitionComponent={Transition}
         keepMounted
         onClose={() => this.handleClose("smallModal")}
         aria-labelledby="small-modal-slide-title"
         aria-describedby="small-modal-slide-description"
       >
         <DialogTitle
           id="small-modal-slide-title"
           disableTypography
           className={classes.modalHeader}
         >
         </DialogTitle>
         <DialogContent
           id="small-modal-slide-description"
           className={classes.modalBody + " " + classes.modalSmallBody}
         >
           <CustomInput
             labelText="Segment Name"
             id="segment_name_data"
             formControlProps={{
               fullWidth: true
             }}
             inputProps={{
               onChange: event =>
                 this.handleChangeInput(event, "segment_name_data"),
               value: this.state.segment_name_data,
             }}
           />
         </DialogContent>
         <DialogActions
           className={classes.modalFooter + " " + classes.modalFooterCenter}
         >
           <Button
              className="btn btncreate"
              onClick={() => this.updateSegment()}
              color="secondary"
            >
              Save
            </Button>
            <Button
              className="btn btncreate"
              color="secondary"
              onClick={() => this.handleClose("smallModal")}
            >
              Cancel
            </Button>
         </DialogActions>
       </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  countSegment: state.countSegment,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  isModalOpenSegment: state.isModalOpenSegment,
  segmentName: state.segmentName
});

export default connect(mapStateToProps)(withStyles(notificationsStyle)(AddGroup));


// WEBPACK FOOTER //
// ./src/views/Audiences/SegmentQueryBuilder/AddGroup.jsx